import { motion } from "framer-motion";
import LeadForm from "../LeadForm";
import { Phone, MessageCircle } from "lucide-react";
import { COMPANY, telLink, buildWhatsAppLink } from "../../lib/site";

export default function SiteVisitCTA() {
  return (
    <section
      data-testid="site-visit-cta"
      className="relative py-28 md:py-40 px-6 md:px-10 border-t border-white/5 overflow-hidden"
    >
      <div
        className="absolute inset-0 -z-10 opacity-30"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 50%, rgba(212,175,55,0.18), transparent 50%), radial-gradient(circle at 80% 80%, rgba(212,175,55,0.1), transparent 50%)",
        }}
      />
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5"
        >
          <div className="eyebrow mb-4">Free Site Visit</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
            Book your{" "}
            <span className="gold-gradient-text italic">free</span> Dholera
            site visit.
          </h2>
          <p className="mt-8 text-white/65 text-lg font-light leading-relaxed">
            See the projects in person. Travel, on-ground guidance and
            refreshments are arranged on us. No obligation. No pressure.
          </p>

          <div className="mt-12 space-y-5">
            <a
              href={telLink(COMPANY.phones[1])}
              data-testid="cta-call-btn"
              className="flex items-center gap-4 group"
            >
              <div className="w-12 h-12 rounded-full border border-[#D4AF37]/40 flex items-center justify-center group-hover:bg-[#D4AF37] transition-all duration-300">
                <Phone
                  className="w-5 h-5 text-[#D4AF37] group-hover:text-black"
                  strokeWidth={1.4}
                />
              </div>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/50">
                  Speak to an advisor
                </div>
                <div className="font-mono text-white text-lg">
                  {COMPANY.phones[1]}
                </div>
              </div>
            </a>
            <a
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-whatsapp-btn"
              className="flex items-center gap-4 group"
            >
              <div className="w-12 h-12 rounded-full border border-[#25D366]/40 flex items-center justify-center group-hover:bg-[#25D366] transition-all duration-300">
                <MessageCircle
                  className="w-5 h-5 text-[#25D366] group-hover:text-white"
                  strokeWidth={1.4}
                />
              </div>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/50">
                  WhatsApp instantly
                </div>
                <div className="font-mono text-white text-lg">
                  {COMPANY.whatsappDisplay}
                </div>
              </div>
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="lg:col-span-7 glass-strong p-8 md:p-12"
        >
          <LeadForm testidPrefix="cta-lead" variant="site-visit-cta" />
        </motion.div>
      </div>
    </section>
  );
}
